import useFeatureFlagValue from '@/components/analytics/hooks/useFeatureFlagValue';

/**
 * PD-6864: Full table service fee by default; set the flag to `v1` to show the per-person fee.
 *
 * Plain feature flag, not an experiment — flip it in GrowthBook without a deploy.
 *
 * @see https://firsttable.atlassian.net/browse/PD-6864
 * @see https://app.growthbook.io/features/booking-service-fee
 */
export const BOOKING_SERVICE_FEE_FLAG = 'booking-service-fee';

export type BookingServiceFeeDisplay = 'control' | 'v1';

export default function useBookingServiceFeeDisplay(): BookingServiceFeeDisplay {
  return useFeatureFlagValue(BOOKING_SERVICE_FEE_FLAG, 'control') === 'v1' ? 'v1' : 'control';
}

export function getBookingFeeLabel(
  display: BookingServiceFeeDisplay,
  fullTableFee: string,
  perDinerFee: string | undefined
): string {
  switch (display) {
    case 'control':
      return `${fullTableFee} service fee`;
    case 'v1':
      return perDinerFee ? `${perDinerFee}pp service fee` : `${fullTableFee} service fee`;
    default: {
      const exhaustiveDisplay: never = display;
      return exhaustiveDisplay;
    }
  }
}
